import React from 'react';
import { bool, string } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  fluid: bool,
  rounded: bool,
  circle: bool,
  shadow: bool,
  src: string.isRequired,
  alt: string.isRequired,
  /** Image is lazy loaded, just for slider images */
  isLazy: bool,
  /** Image have more variants for more displays */
  isResponsive: bool,
};

const CLASS_ROOT = 'img';

const Image = ({
  className,
  fluid,
  rounded,
  circle,
  shadow,
  src,
  alt,
  isLazy,
  isResponsive = true,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--fluid`]: fluid,
      [`${CLASS_ROOT}--rounded`]: rounded,
      [`${CLASS_ROOT}--circle`]: circle,
      [`${CLASS_ROOT}--shadow`]: shadow,
      'tns-lazy-img': isLazy,
    },
    className
  );

  const srcReplace = src.replace(/@2x\.(\w+)$/, '.$1');
  const sourceSrc = isLazy
    ? {
        'data-srcset': srcReplace,
      }
    : {
        srcSet: srcReplace,
      };
  const imgSrc = isLazy ? { 'data-src': src } : { src };
  const img = <img className={classes} {...imgSrc} alt={alt} {...other} />;

  return isResponsive ? (
    <picture>
      <source media="(max-width: 480px)" {...sourceSrc} />
      {img}
    </picture>
  ) : (
    img
  );
};

Image.displayName = 'Image';
Image.propTypes = propTypes;

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.js